import { BuilderContext, teamAColor, teamBColor } from "@Context/game/builder/builder-context";
import { faArrowsRotate, faUserPlus } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Typography } from "@mui/material";
import { Point } from "@Shared/types/ScenarioTypes";
import { Menu, MenuItem, SubMenu } from "@spaceymonk/react-radial-menu";
import { useContext } from "react";
import { addPlayer } from "./functions/player-functions";
import { FieldPosition, Player } from "./models/builder-data-types";
import RadialItem from "./radial-item";

const FieldMenu = () => {
  const { state, dispatch } = useContext(BuilderContext);
  const { i18n } = useI18n();

  const handleAddPlayerClick = (point: Point, fieldPosition: FieldPosition, team: number) => {
    addPlayer(state, dispatch, point, fieldPosition, team);
    dispatch({ showFieldRadial: false });
  };

  const handleClose = () => {
    dispatch({ showFieldRadial: false });
  };

  const handleFlipTeams = () => {
    dispatch({ showFieldRadial: false });

    const newPlayers = new Map<number, Player>();

    Array.from(state.clip.scenario.players.keys()).forEach((key) => {
      const player = { ...state.clip.scenario.players.get(key) };
      if (player) {
        player.team = player.team === 1 ? 2 : 1;
        newPlayers.set(key, player as Player);
      }
    });

    dispatch({
      clip: {
        ...state.clip,
        scenario: {
          ...state.clip.scenario,
          players: newPlayers,
        },
      },
    });
  };

  return (
    <Menu
      centerX={state.radialAnchor.x}
      centerY={state.radialAnchor.y}
      innerRadius={50}
      outerRadius={160}
      show={state.showFieldRadial}
      animation={["fade", "scale"]}
      animationTimeout={120}
      theme="dark"
      drawBackground={true}
    >
      <MenuItem onItemClick={handleFlipTeams} data="1.1. Item">
        <RadialItem icon={faArrowsRotate} text={i18n("builder.field.flip.teams")} />
      </MenuItem>
      {state.availableOpponents.length > 1 ? (
        <SubMenu
          itemView={
            <>
              <RadialItem icon={faUserPlus} colour={teamBColor} text={i18n("builder.field.add.opponent")} />
            </>
          }
          data="2. Sub Menu"
          displayPosition="center"
        >
          {state.availableOpponents.map((fieldPosition) => (
            <MenuItem onItemClick={() => handleAddPlayerClick(state.selectedPosition, fieldPosition, 2)} data="2.1. Item">
              <Typography sx={{ color: teamBColor }}>{fieldPosition.initials}</Typography>
            </MenuItem>
          ))}
        </SubMenu>
      ) : state.availableOpponents.length > 0 ? (
        <MenuItem onItemClick={() => handleAddPlayerClick(state.selectedPosition, state.availableOpponents[0], 2)} data="2.1. Item">
          <Typography sx={{ color: teamBColor }}>{i18n("builder.field.opponent", { initials: state.availableOpponents[0].initials })}</Typography>
        </MenuItem>
      ) : (
        <MenuItem onItemClick={handleClose} data="2.1. Item">
          {i18n("builder.field.close")}
        </MenuItem>
      )}
      {state.availableTeamMates.length > 1 ? (
        <SubMenu
          itemView={
            <>
              <RadialItem icon={faUserPlus} colour={teamAColor} text={i18n("builder.field.add.team.mate")} />
            </>
          }
          data="2. Sub Menu"
          displayPosition="center"
        >
          {state.availableTeamMates.map((fieldPosition) => (
            <MenuItem onItemClick={() => handleAddPlayerClick(state.selectedPosition, fieldPosition, 1)} data="2.1. Item">
              <Typography sx={{ color: teamAColor }}>{fieldPosition.initials}</Typography>
            </MenuItem>
          ))}
        </SubMenu>
      ) : state.availableTeamMates.length > 0 ? (
        <MenuItem onItemClick={() => handleAddPlayerClick(state.selectedPosition, state.availableTeamMates[0], 1)} data="2.1. Item">
          <Typography sx={{ color: teamAColor }}>{i18n("builder.field.team.mate", { initials: state.availableTeamMates[0].initials })}</Typography>
        </MenuItem>
      ) : (
        <MenuItem onItemClick={handleClose} data="2.1. Item">
          {i18n("builder.field.close")}
        </MenuItem>
      )}
    </Menu>
  );
};

export default FieldMenu;
